
<template>
    <v-dialog v-model="showFilterDialog" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <v-btn flat icon v-on:click.stop="toggleFilter()">
                    <v-icon large>close</v-icon>
                </v-btn>                
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-radio-group v-model="target" row>
                                <v-radio label="Marken" value="marken" ></v-radio>
                                <v-radio label="Firmen" value="firmen"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-select                                 
                                label="Types Filter"   
                                multiple
                                chips
                                dark              
                                cache-items
                                
                                v-bind:items="dialogTypes"     
                                item-text="name"
                                item-value="id"
                                
                                v-model="filterTypes"></v-select>     
                         </v-flex>
                        <v-flex xs12 sm6>
                            <v-select                                                 
                                label="Warengruppen Filter"    
                                autocomplete
                                multiple
                                chips
                                dark              
                                cache-items
                                
                                v-bind:items="dialogWarengruppen"     
                                item-text="name"
                                item-value="id"
                                
                                v-model="filterWarengruppen"></v-select>     
                         </v-flex>
                    </v-layout>
                  </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn block v-on:click="engageFilter">
                    Filter
                </v-btn>
            </v-card-actions>
        </v-card>
        
    </v-dialog>
</template>

<script>
export default {
        
    mounted: function() {
        
        if(this.$dmAuth.isAuthenticated()) {
            this.$store.dispatch("setTypes")       
            this.$store.dispatch("setWarengruppen")
        }        
    },    
    data() {
        return {
            filterTypes: [],
            filterWarengruppen: [],
            target: 'marken'
        }
    },  
    computed: {
        showFilterDialog: function() {
            return this.$store.getters.showFilterDialog
        },
        dialogTypes: function() {            
            return this.$store.getters.types
        },
        dialogWarengruppen: function() {
            return this.$store.getters.warengruppen
        },
        mk: function() {
            return this.$store.getters.marken
        },
        fa: function() {
            return this.$store.getters.firmen
        },
        loading: function () {
            return this.$store.getters.loading
        }
                
    },
    methods: {
        
        toggleFilter: function() {
            this.filterTypes = []
            this.filterWarengruppen = []
            this.$store.commit('showFilterDialog', false)
        },
        
        filterFirmaByWarengruppe: function () {
            
            return this._.filter(this.fa, (f) => {
                return this._.some(f.marken, (m) => {
                    return this._.some(m.warengruppen, (w) => {
                        if (this.filterWarengruppen.length >0) {
                            return this._.includes(this.filterWarengruppen, w.id)
                        }
                        return true
                    })
                })
            })
        },
        filterFirmaByType: function () {
            
            return this._.filter(this.fa, (f) => {
                return this._.some(f.marken, (m) => {
                    return this._.some(m.types, (t) => {
                        if (this.filterTypes.length >0) {
                            return this._.includes(this.filterTypes, t.id)
                        }
                        return true
                    })
                })
            })
        },
        filterMarkeByWarengruppe: function () {
            
            return this._.filter(this.mk, (m) => {
                return this._.some(m.warengruppen, (w) => {
                    
                    if (this.filterWarengruppen.length>0) {                        
                            return this._.includes(this.filterWarengruppen, w.id)
                        }
                        return true
                })
            })
        },
        filterMarkeByType: function () {
            
            return this._.filter(this.mk, (m) => {
                return this._.some(m.types, (t) => {
                    if (this.filterTypes.length >0) {
                            return this._.includes(this.filterTypes, t.id)
                        }
                        return true
                })
            })
        },
        
        filterFirma: function () {
            return this._.intersectionBy(this.filterFirmaByType(), this.filterFirmaByWarengruppe(), this.fa)
        },
        filterMarke: function () {
         
            return this._.intersectionWith( this.filterMarkeByType(),this.filterMarkeByWarengruppe(), this._.isEqual)
        },
        engageFilter: function () {
            if(this.target === 'marken') {
                this.$store.dispatch('setPreFilteredMarken',this.filterMarke())
                this.$router.push('/marken')
            } else {
                this.$store.dispatch('setPreFilteredFirmen',this.filterFirma())
                this.$router.push('/firmen')
            }
            
            this.toggleFilter()
        }
        
    }    
}
</script>

<style>
    


</style>


// WEBPACK FOOTER //
// FilterModal.vue?2e3d8fe8